import React from 'react';
import type { WeatherLayer } from '../types';
import { TICKER_LAYERS } from '../utils/tickerMetric';
import { SunIcon, WindIcon, RainIcon } from './icons/OnTheRouteIcons';

type TickerMetricToggleProps = {
  value: WeatherLayer;
  onChange: (layer: WeatherLayer) => void;
};

function LayerIcon({ id, active }: { id: WeatherLayer; active: boolean }) {
  const color = active ? 'var(--accent)' : 'var(--label2)';
  if (id === 'temp') return <SunIcon size={18} color={color} />;
  if (id === 'wind') return <WindIcon size={18} color={color} />;
  return <RainIcon size={18} color={color} />;
}

export const TickerMetricToggle: React.FC<TickerMetricToggleProps> = ({ value, onChange }) => {
  const ids = TICKER_LAYERS.map((l) => l.id);

  const move = (delta: number) => {
    const i = ids.indexOf(value);
    const next = ids[(i + delta + ids.length) % ids.length]!;
    onChange(next);
  };

  return (
    <div
      role="radiogroup"
      aria-label="Route ticker metric"
      className="seg-control ticker-metric-toggle"
      onKeyDown={(e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          move(1);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          move(-1);
        } else if (e.key === 'Home') {
          e.preventDefault();
          onChange(ids[0]!);
        } else if (e.key === 'End') {
          e.preventDefault();
          onChange(ids[ids.length - 1]!);
        }
      }}
    >
      {TICKER_LAYERS.map((layer) => {
        const active = value === layer.id;
        return (
          <button
            key={layer.id}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={layer.ariaLabel}
            title={layer.ariaLabel}
            className={`seg-item${active ? ' active' : ''}`}
            onClick={() => onChange(layer.id)}
          >
            <LayerIcon id={layer.id} active={active} />
            <span className="visually-hidden">{layer.label}</span>
          </button>
        );
      })}
    </div>
  );
};
